<template>
  <TemplateDbsSelectCycle v-if="isReadyToDraw" />

  <DialogInitialLoading v-else />
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import API from "@/API";
import TemplateDbsSelectCycle from "@/views/Templates/Dbs/TemplateDbsSelectCycle";

export default {
  name: "DbsSelectCycle",
  components: {
    TemplateDbsSelectCycle,
  },
  setup() {
    const route = useRoute();
    const isReadyToDraw = ref(false);

    // 自転車情報を最新に保つため、定期的にGETする
    const startInterval = () => {
      setInterval(
        () => API.getDbsPark(route.params.park_id),
        1000 * 15
      );
    }
     
    onMounted(async () => {
      await API.getDbsPark(route.params.park_id);
      isReadyToDraw.value = true;
      startInterval();
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
